import { z } from "zod";

export const CampaignOpportunityFieldsSchema = z.object({
  id: z.number().int(),
  title: z.string(),
  description: z.string(),
  value: z.string(),
  currency: z.string(),
  startDate: z.string(),
  modificationDate: z.string(),
  estimatedCloseDate: z.string(),
  realCloseDate: z.string(),
  status: z.string(),
  lostCausedBy: z.any(),
  lostDescription: z.any(),
  ordering: z.any(),
});
export const PartialCampaignOpportunityFieldsSchema =
  CampaignOpportunityFieldsSchema.deepPartial();

export const CampaignOpportunityExtraFieldsSchema = z.object({
  accountUser: z.any(),
  campaign: z.any(),
  campaignPhase: z.any(),
  company: z.any(),
  creatorUser: z.any(),
});
export const PartialCampaignOpportunityExtraFieldsSchema =
  CampaignOpportunityExtraFieldsSchema.deepPartial();

export const CampaignOpportunitySchema = z.intersection(
  CampaignOpportunityFieldsSchema,
  CampaignOpportunityExtraFieldsSchema
);

export type CampaignOpportunityFields = z.infer<
  typeof CampaignOpportunityFieldsSchema
>;
export type PartialCampaignOpportunityFields = z.infer<
  typeof PartialCampaignOpportunityFieldsSchema
>;
export type CampaignOpportunityExtraFields = z.infer<
  typeof CampaignOpportunityExtraFieldsSchema
>;
export type PartialCampaignOpportunityExtraFields = z.infer<
  typeof PartialCampaignOpportunityExtraFieldsSchema
>;
export type CampaignOpportunity = z.infer<typeof CampaignOpportunitySchema>;
